import { Country } from '@dreryk/address-common-api';
import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { MedicalDataAccessAuthorizationFormBean } from '../MedicalDataAccessAuthorizationModal/MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm.types';
import { createAuthorizedPersonIdentifierFormBean } from '../../../common/PersonForm/AuthorizedPersonIdentifier/authorizedPersonIdentifier';

export const mapMedicalDataAccessAuthorizationToFormBean = (
   data: MedicalDataAccessAuthorization
): MedicalDataAccessAuthorizationFormBean => {
   return {
      country: data.address?.getCountry() ?? Country.DEFAULT,
      documentationAccess: data.forDocumentation,
      firstName: data.firstName.asString(),
      flat: data.address?.findFlat()?.asString() ?? null,
      house: data.address?.findBuilding()?.asString() ?? null,
      informationAccess: data.forInformation,
      middleName: data.middleName?.asString() ?? null,
      lastName: data.lastName.asString(),
      phoneNumber: data.phoneNumber ?? null,
      postcode: data.address?.findPostcode() ?? null,
      street: data.address?.findStreet()?.asString() ?? null,
      town: data.address?.findTown()?.getName() ?? null,
      ...createAuthorizedPersonIdentifierFormBean(data.externalIdentifier, data.birthDate),
   };
};
